<template>
  <FormValidation @submit="submit" :initData="{ title:'User registration', btn:'Register now' }" :formObj="formObj"/>
</template>

<script>
import { Toast, } from 'mint-ui';
import FormValidation from "../../../components/app/formValidation";
import { reqRegEn } from "../../../api";
export default {
  components:{
    FormValidation
  },
  data(){
    
    return{
      formObj:{}
    }
  },
  mounted(){
  },
  methods:{
    async submit(){
      const response =await reqRegEn(this.form)
      console.log(response);
      if (response.code*1==2) {
        Toast({position: 'top',message: 'Registered Successful'})
        this.$router.push('/login')
      }else{
        Toast({position:'top',message:'Registered failure'})
      }
    },
  }
}
</script>

<style scoped>
  .registered{
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: white;
    background-image: url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/login_bg.png');
    background-size: 100% 100%;
  }
  .login_content{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    height: 100%;
  }
  .login_img{
    max-width: 140px;
    margin: auto;
    padding: 40px 0 10px;
  }
  .email_login{
    padding: 20px 40px;
  }
  .email_login >>> .el-input__inner{
    color: #b8b8b8;
  }
  .registered .input_Code{
    width: calc(100% - 130px);
    margin-right: 18px;
    vertical-align: top;
  }
  .btn_Code{
    width: 112px;
    padding-left: 0;
    padding-right: 0;
  }
  .login_icon{
    position: absolute;
    left: -46px;
    top: 4px;
    width: 32px;
    height: 32px;
    margin-top: 4px;
  }
  .email_login p{
    font-size: 12px;
    color: #b8b8b8;
    text-align: end;
  }
  .retrieve_password{
    margin-top: -5px;
  }

  .email_login .new_email{
    text-align: center;
  }
  .new_email span{
    color: #fae655;
  }
  #app .login >>> .el-input.is-active .el-input__inner,#app .login >>> .el-input__inner:focus{
    border-color: #fae655;
  }
  /* .login_type{
    margin-top: 30px;
    margin-left: -40px;
    font-size: 12px;
  }
  .login_type>>> .el-form-item__content{
    font-size: 12px;
    line-height: 20px;
  }
  .login_type>>> .el-form-item__content span{
    font-size: 12px;
    vertical-align: top;
  } */
  .email_login>>>.el-select{
    display: block;
  }
  /* .login_type >>> .el-checkbox__input.is-checked .el-checkbox__inner,
  .login_type >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #008baf;
    border-color: #008baf;
  }
  .login_type >>> .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #008baf;
  } */
  .agreement{
    color: #d6c751;
  }
  .login_button{
    padding-top: 20px;
    margin-left: -50px;
  }
  .login_button button{
    width: 100%;
    border-radius: 20px;
    background-image: linear-gradient(#fffa81,#f2c409);
    border: none;
    color: white;
    font-weight: 600;
  }
  .login_button button:focus{
    color: white;
  }
</style>
<style>
  .inoput_underline input{
    background-color: transparent;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #aaa;
    padding: 0 6px;
  }
  .inoput_underline input:focus,
  .inoput_underline input:hover{
    border-color: #aaa;
  }
  
</style>